/**
 * Convert a cent integer to a display dollar value.
 * Returns `undefined` when the input is null/undefined so the
 * controlled InputNumber renders as empty.
 */
export function centsToDollars(
  cents: number | null | undefined
): number | undefined {
  if (cents == null) return undefined
  return cents / 100
}

/**
 * Convert a dollar amount (as entered by the user) back to a cent integer.
 * Returns `undefined` for empty/null input so the RHF field value is cleared.
 * Uses `Math.round` to avoid floating-point drift (e.g. 10.07 * 100 = 1006.9999…).
 */
export function dollarsToCents(
  dollars: number | string | null | undefined
): number | undefined {
  if (dollars === null || dollars === undefined || dollars === "")
    return undefined
  return Math.round(Number(dollars) * 100)
}

/**
 * Convert a cent value to a dollar constraint for InputNumber's min/max props.
 * Returns `undefined` when no constraint is provided.
 */
export function centsToMinMax(cents: number | undefined): number | undefined {
  if (cents == null) return undefined
  return cents / 100
}
